module.exports = __webpack_public_path__ + "img/1202756510.7ba72f40.jpg";